var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables35 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "780.342px",
    height: "578.227px",
    viewBox: "0 0 780.342 578.227",
    enableBackground: "new 0 0 780.342 578.227",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.942,31.342L653.095,0l127.247,153.608l-41.287,19.795 c52.319,219.76-59.112,432.265-304.563,401.919c-100.445-12.438-167.92-77.776-245.281-100.764C74.587,440.473,0,474.559,0,474.559 l68.372-68.159C230.089,257.842,414.292,128.817,634.942,31.342L634.942,31.342z M277.269,407.541 c135.569-6.914,256.104-21.977,421.345-171.932c-9.302-24.766-18.607-49.563-27.888-74.353 C539.563,243.372,408.432,325.469,277.269,407.541z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables35, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-35.eda74348.svg";
export { ForwardRef as ReactComponent };